export class ReverseTransaction {
  actionTypeCode? : string;
  effectiveDate? : number;
  fannieMaeLoanNumber? : string;
  transactionAmount? : string;
  servicerNumber? : string;
  transactionDesignator? : string;
  originalTransactionID? : string;
  userId? : string; 
}
